import styled from "styled-components";
import { device } from "../../../utils/helpers/breakpoints";

export const BottomNavContainer = styled.div`
  background-color: white;
  width: 100%;
  display: none;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  border-top: 1px solid rgb(230, 230, 230);
  padding-bottom: 10px;
  padding-top: 5px;

  @media ${device.tablet} {
    display: flex;
  }
`;
